<template>
  <v-row>
    <v-col cols="12" md="6" lg="4" v-for="token of allTokens" :key="token.id">
      <TokenListCard :token="token" />
    </v-col>
  </v-row>
</template>

<script lang="ts" setup>
import { computed, defineProps } from "vue";
import TokenListCard from "@/components/Tokens/TokenListCard.vue";

const props = defineProps({
  pages: { type: Array, default: null },
});

const allTokens = computed(() =>
  props.pages?.length ? props.pages.map((page) => page.items).flat() : []
);
</script>
